import { createSlice } from '@reduxjs/toolkit';

// utils
import axios from 'utils/axios';
import { ACTIONS } from 'utils/constants';

//
import API from 'restApi';

import { dispatch, store } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  messages: [],
  navig: {
    total: 0,
    nav_position: 0,
    nb_item_per_page: 10
  }

};

const slice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.messages = [];
      state.navig = initialState.navig;

    },

    // GET Messages
    getMessagesSuccess(state, action) {
      const { data, navig } = action.payload;
      state.isLoading = false;
      state.messages = data;
      state.navig = navig;
      state.error = null;

    },
    // GET Contract
    getMessagesuccess(state, action) {
      state.isLoading = false;
      state.demand = action.payload;
    },

    //  SORT & FILTER Messages
    sortByMessages(state, action) {
      state.sortBy = action.payload;
    },
    //  SORT & FILTER Messages
    paginationMessages(state, action) {
      state.navig = { ...state.navig, nav_position: action.payload };
    },

    resetMessages(state) {
      state.messages = initialState.messages;
      state.navig = initialState.navig;
    }

  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  sortByMessages,
  paginationMessages,
  resetMessages
} = slice.actions;

// ----------------------------------------------------------------------

export function getMessages({ profile, staffcode }) {
  const { message: { navig }, all: { config } } = store.getState();

  return async () => {
    dispatch(slice.actions.startLoading());

    try {

      const response = await axios.post(API.path, {
        navig: {
          total: navig.total,
          nav_position: navig.nav_position,
          nb_item_per_page: config?.nbItemPerPage
        },
        profile,
        staffcode,
        action: ACTIONS.LOADMESSAGE
      });
      const { data } = response;
      dispatch(slice.actions.getMessagesSuccess(data));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
